import React from 'react';

/**
 * The product's signature element: a masked value shown as a calm, deliberate
 * chip — ‹PERSON›, ‹PHONE› — instead of raw <PERSON> text (which reads like a
 * glitch). Used in the Cockpit before→becomes preview and in Test Model.
 */
const RedactionChip = ({ type, style }) => (
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontFamily: 'var(--sc-mono)',
            fontSize: '0.86em',
            fontWeight: 600,
            lineHeight: 1.4,
            padding: '0 7px',
            borderRadius: 'var(--sc-r-chip, 8px)',
            background: 'var(--sc-inset, #F1ECE4)',
            border: '1px solid var(--sc-border, #ECE6DD)',
            color: 'var(--sc-ink-2, #6C6459)',
            whiteSpace: 'nowrap',
            verticalAlign: 'baseline',
            ...style,
        }}
    >
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" style={{ opacity: 0.45, flex: 'none' }}>
            <rect x="4" y="10" width="16" height="10" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
        </svg>
        ‹{type}›
    </span>
);

export default RedactionChip;
